<template>
  <div class="sp_bottom_menu">
    <div class="sp_bottom_menu_1">
      <div class="color_change_sp">
        <input type="checkbox" id="color_change_sp" @click="toggleTheme(null)" :checked="this.chatThemeDark" />
        <label for="color_change_sp">
          <span></span>
        </label>
      </div>
      <div class="action_bar" v-if="this.isAllowedManageActions">
        <button type="button" class="action_btn" @click="downloadMessages()" :disabled="this.isDownloadDisabled">
          <span>{{ $t('chatBox.downloadChatCsv') }}</span>
        </button>

        <button type="button" class="action_btn" onclick="window.print()">
          <span>{{ $t('chatBox.printChat') }}</span>
        </button>
      </div>
      <div class="question_sp">
        <a :href="this.lessonDetails.faq_link">
          <img src="@/assets/img/question_icon_sp@2x.png" alt=""/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('chatHistory', [
      'lessonDetails', 
      'isAllowedManageActions', 
      'chatThemeDark', 
      'isDownloadDisabled'
    ]),
  },
  methods: {
    ...mapActions('chatHistory', ['toggleTheme', 'downloadMessages']),
  }
};
</script>
